// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rc-tooltip{display:none;position:absolute;-webkit-transition:all .3s cubic-bezier(.645,.045,.355,1);-o-transition:all .3s cubic-bezier(.645,.045,.355,1);transition:all .3s cubic-bezier(.645,.045,.355,1);z-index:var(--zIndex-tooltip);max-width:300px;max-width:18.75rem;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media(hover:hover){.rc-tooltip{display:block}}.rc-tooltip-hidden{display:none}.rc-tooltip-inner{min-height:unset;border:none;padding:.5rem;color:#fff;background:#231815;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:.25rem;font-size:14px;font-weight:300;line-height:23px;font-family:var(--base-font)}@media(max-width:767px){.rc-tooltip-inner{font-size:16px;line-height:26px}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440"
};
module.exports = exports;
